// eslint-disable-next-line import/no-extraneous-dependencies
import {
  DefaultLocalConfig,
  DefaultProductionConfig,
  DefaultStagingConfig,
  defineConfig,
} from '@gms/app-config';
import { AudiTheme } from '@gms/vuetify2-themes/';

export default defineConfig({
  local: {
    ...DefaultLocalConfig,
    theme: AudiTheme,
  },
  'audi-staging': {
    ...DefaultStagingConfig,
    theme: AudiTheme,
  },
  'audi-prod': {
    ...DefaultProductionConfig,
    api: {
      baseUrl: 'https://reservation-api.charging-hub.audi/v4',
      clientId: '77cdcf98-c9ca-464d-a706-cf863134b639',
    },
    theme: AudiTheme,
    urls: [/reservation\.charging-hub\.audi/],
  },
});
